/**
 * Accessibility utilities
 */

/**
 * Initialize accessibility features
 */
export function initA11y(): void {
  addSkipLink();
  handleFocusVisibility();
  improveImageAccessibility();
}

/**
 * Add skip to main content link
 */
function addSkipLink(): void {
  const mainContent = document.querySelector('main');
  if (!mainContent || mainContent.id) return;

  mainContent.id = 'main-content';

  const skipLink = document.createElement('a');
  skipLink.href = '#main-content';
  skipLink.textContent = 'Skip to main content';
  skipLink.className = 'sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-primary focus:text-white';

  document.body.insertBefore(skipLink, document.body.firstChild);
}

/**
 * Handle focus visibility for keyboard vs mouse users
 */
function handleFocusVisibility(): void {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      document.body.classList.add('user-is-tabbing');
    }
  });

  document.addEventListener('mousedown', () => {
    document.body.classList.remove('user-is-tabbing');
  });
}

/**
 * Improve image accessibility
 */
function improveImageAccessibility(): void {
  const images = document.querySelectorAll('img:not([alt])');
  images.forEach((img) => {
    img.setAttribute('alt', '');
    console.warn('Image without alt attribute:', img);
  });
}

/**
 * Announce to screen readers
 */
export function announceToScreenReader(message: string, priority: 'polite' | 'assertive' = 'polite'): void {
  const announcement = document.createElement('div');
  announcement.setAttribute('role', 'status');
  announcement.setAttribute('aria-live', priority);
  announcement.className = 'sr-only';
  announcement.textContent = message;

  document.body.appendChild(announcement);

  setTimeout(() => {
    document.body.removeChild(announcement);
  }, 1000);
}
